import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import $ from '@vaersaagod/tools/Dom';
import * as Events from '../lib/events';

export default el => {
    const OFFSET_BUFFER = 10;
    const OFFSET_TOP = 30;
    const GROW_AMOUNT = {
        none: 14,
        s: 14,
        sp: 14,
        m: 14,
        mp: 14,
        l: 14,
        lp: 20,
        xl: 20
    };

    const BG_AMOUNT = {
        none: 27,
        s: 27,
        sp: 27,
        m: 27,
        mp: 27,
        l: 27,
        lp: 40,
        xl: 40
    };

    let isOpen = false;
    let scrollingLocked = false;
    let lastTop = Viewport.scroll.top;
    let headerShowing = true;
    // let scrollBeforeLock = 0;
    let isSmall = false;
    let growAmount = GROW_AMOUNT[Viewport.breakpoint.name];
    let bgAmount = BG_AMOUNT[Viewport.breakpoint.name];

    const dom = $(el);
    // const $body = $('body');
    const $bar = dom.find('[data-header-bar]');
    const $content = dom.find('[data-header-content]');
    const logo = dom.find('[data-logo]');
    const nav = dom.find('[data-nav]');
    const openToggle = dom.find('[data-open]');
    const closeToggle = dom.find('[data-close]');

    // const $toggles = dom.find('[data-toggles]');

    const open = () => {
        if (!isOpen) {
            isOpen = true;
            dom.addClass('is-open');
            Viewport.lockTabbing([logo.get(0), nav.get(0), closeToggle.get(0)], closeToggle);
        }
    };

    const close = () => {
        if (isOpen) {
            isOpen = false;
            dom.removeClass('is-open');
            Viewport.releaseTabbing(openToggle);
        }
    };

    const emitMenuOpen = () => {
        Dispatch.emit(Events.MENU_OPEN);
    };

    const emitMenuClose = () => {
        Dispatch.emit(Events.MENU_CLOSE);
    };

    const onOpenClick = e => {
        e.preventDefault();
        emitMenuOpen();
        scrollingLocked = true;
    };

    const onCloseClick = e => {
        e.preventDefault();
        emitMenuClose();
        scrollingLocked = false;
    };

    const toggleSize = shouldBeBig => {
        if (shouldBeBig && isSmall) {
            isSmall = false;
            TweenMax.to($content.get(0), 0.35, { y: 0, ease: 'Quad.easeOut' });
            TweenMax.to($bar.get(0), 0.35, { y: 0, ease: 'Quad.easeOut' });
        } else if (!shouldBeBig && !isSmall) {
            isSmall = true;
            TweenMax.set($content.get(0), { y: -growAmount });
            TweenMax.set($bar.get(0), { y: -bgAmount });
        }
    };

    const show = () => {
        if (!headerShowing) {
            console.log('Header.show');
            headerShowing = true;
            TweenMax.to($content.get(0), 0.35, { yPercent: 0, ease: 'Quad.easeOut' });
            TweenMax.to($bar.get(0), 0.35, { yPercent: 0, ease: 'Quad.easeOut' });
        }
    };

    const hide = () => {
        if (headerShowing) {
            console.log('Header.hide');
            headerShowing = false;
            TweenMax.to($content.get(0), 0.35, { yPercent: -100, ease: 'Quad.easeIn' });
            TweenMax.to($bar.get(0), 0.35, { yPercent: -100, ease: 'Quad.easeIn' });
            isSmall = lastTop > OFFSET_TOP;
        }
    };

    const onScroll = () => {
        if (!scrollingLocked) {
            const top = Viewport.scroll.top;
            if (Math.abs(top - lastTop) > OFFSET_BUFFER) {
                const isScrollingUp = top < lastTop;

                if (isScrollingUp) {
                    show();
                    toggleSize(top < 100);
                } else if (top > OFFSET_TOP) {
                    hide();
                    // toggleSize(false);
                }

                lastTop = top;
            }
        }
    };

    // const lockScrolling = () => {
    //     if (!scrollingLocked) {
    //         Dispatch.emit(Events.SCROLL_LOCKED);
    //         const scrollbarWidth = Viewport.width - $body.width();
    //         scrollBeforeLock = Viewport.scrollTop;
    //
    //         if (scrollbarWidth > 0) {
    //             TweenMax.set($body.get(0), { width: this.$body.width() });
    //             TweenMax.set(this.$menuWrap.get(0), { width: Viewport.width });
    //
    //             if (Viewport.breakpoint.size < 1250) {
    //                 TweenLite.set([this.$searchTrigger.get(0), this.$toggles.get(0), this.$toggles.get(1)], { right: `+=${scrollbarWidth}` });
    //             } else {
    //                 TweenLite.set(this.$el.get(0), { width: this.$body.width() });
    //             }
    //         }
    //
    //         TweenLite.set(this.$body.get(0), { overflow: 'hidden' });
    //         // Viewport.lockScrolling();
    //     }
    // };
    //
    // const unlockScrolling = () => {
    //
    // };

    const onScrollLock = () => {
        scrollingLocked = true;
    };

    const onScrollUnlock = () => {
        scrollingLocked = false;
    };

    const onBreakpoint = () => {
        growAmount = GROW_AMOUNT[Viewport.breakpoint.name];
        bgAmount = BG_AMOUNT[Viewport.breakpoint.name];
        if (isSmall) {
            isSmall = false;
            toggleSize(false);
        }
    };

    const onFocus = () => {

        if (!headerShowing) {
            console.log('onFocus');
            show();
            toggleSize(lastTop < OFFSET_TOP);
        }
    };

    const init = () => {
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
        Dispatch.on(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.on(Events.SCROLL_UNLOCKED, onScrollUnlock);
        dom.on('click', '[data-open]', onOpenClick);
        dom.on('click', '[data-close]', onCloseClick);
        dom.on('focusin', onFocus);
        Viewport.on('scroll', onScroll);
        Viewport.on('breakpoint', onBreakpoint);
        toggleSize(lastTop < OFFSET_TOP);
    };

    const destroy = () => {
        dom.off('click');
        dom.off('focusin');
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        Dispatch.off(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.off(Events.SCROLL_UNLOCKED, onScrollUnlock);
        Viewport.off('scroll', onScroll);
        Viewport.off('breakpoint', onBreakpoint);
        Viewport.releaseTabbing();

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Header.js